import React from 'react';

import SoftyGrupo from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftyGrupo/List.js';

export default function () {
  return <SoftyGrupo />;
}
